import {
  ComplianceEntity,
  ComplianceEntityUsTaxStatus
} from "@wingspanhq/wingspan-api-sdk";
import { FormDataAccountType } from ".";
import { selectorComplianceEntityCountry } from "../../../../shared/selectors/selectorComplianceEntityCountry";

export function getProfileDataAccountType(
  monitoredEntity: ComplianceEntity | undefined
): Partial<FormDataAccountType> {
  const country = selectorComplianceEntityCountry(monitoredEntity);

  return {
    country,
    type: monitoredEntity?.type,
    // v1 read this off the v2 US tax profile; the entity carries its own US tax status.
    isUsPerson:
      country !== "US" &&
      monitoredEntity?.usTaxStatus === ComplianceEntityUsTaxStatus.US_PERSON
  };
}
